<template lang="pug"></template>

<script>
export default {
    name: 'BotaoPreAnaliseCredito',
    componentOptions: {
        title: 'Pré-Análise de Crédito',
        actions: [
            [
                {
                    name: 'Pré-Análise de Crédito',
                    iconClass: 'lyra-icon lyra-pre-analise-credito',
                    showView: false,
                    action: 'abrirPreAnaliseCredito',
                    route: 'PreAnaliseCredito'
                }
            ]
        ]
    },

    methods: {
        abrirPreAnaliseCredito() {
            if (this.$route.name !== 'PreAnaliseCredito') {
                this.$router.push({ name: 'PreAnaliseCredito' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
